// light -> 300
// regular -> 400
// medium -> 500
// semibold -> 600
// bold -> 700

const typography = {
    fontFamily: 'Pretendard',
    body1: {
        fontSize: '18px',
        fontWeight: 500,
        lineHeight: 1.5 // 150%
    },
    body2: {
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: 1.5
    },
    body3: {
        fontSize: '15px',
        fontWeight: 500,
        lineHeight: 1.5
    },
    body4: {
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: 1.5
    },
    body5: {
        fontSize: '13px',
        fontWeight: 600,
        lineHeight: 1.5
    },
    subtitle1: {
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: 1.5
    },
    subtitle2: {
        fontSize: '15px',
        fontWeight: 400,
        lineHeight: 1.5
    },
    subtitle3: {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: 1.5
    },
    subtitle4: {
        fontSize: '13px',
        fontWeight: 400,
        lineHeight: 1.5
    }
};
  
export default typography;
